import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const CATEGORIAS = {
  retos:     { label:'Retos del Bogotalogo', en:'Bogotalogo Challenges', ic:'🔥', color:'#7C3AED' },
  curriculo: { label:'Curriculo A1-C2',      en:'A1-C2 Curriculum',      ic:'📚', color:'#3B82F6' },
  racha:     { label:'Racha de dias',        en:'Streak days',           ic:'🔥', color:'#EF4444' },
  clases:    { label:'Clases en vivo',       en:'Live classes',          ic:'🎥', color:'#1B3A8C' },
  foros:     { label:'VideoForos',           en:'VideoForums',           ic:'🎙', color:'#059669' },
  especial:  { label:'Especiales',           en:'Special',               ic:'⭐', color:'#F59E0B' },
}

const TX = {
  es: {
    titulo: 'Mis Insignias', subtitulo: 'Gana insignias completando actividades en EspañolGo.', ganadasLbl: 'insignias ganadas',
    completado: 'completado', todas: 'Todas', ganadas: '✅ Ganadas', pendientes: '🔒 Pendientes', badgeGanada: '✓ Ganada',
    ganadaEl: 'Ganada el', locale: 'es-CO',
    reto: 'Completa el reto ', retosA: 'Completa ', retosB: ' retos', lecA: 'Completa ', lecB: ' lecciones',
    rachaA: 'Mantén racha de ', rachaB: ' días', clasesA: 'Asiste a ', clasesB: ' clase(s)',
    forosA: 'Participa en ', forosB: ' foro(s)', xpA: 'Acumula ', xpB: ' XP', nivel: 'Completa el nivel ', req: 'Cumple el requisito'
  },
  en: {
    titulo: 'My Badges', subtitulo: 'Earn badges by completing activities in EspañolGo.', ganadasLbl: 'badges earned',
    completado: 'complete', todas: 'All', ganadas: '✅ Earned', pendientes: '🔒 Locked', badgeGanada: '✓ Earned',
    ganadaEl: 'Earned on', locale: 'en-US',
    reto: 'Complete challenge ', retosA: 'Complete ', retosB: ' challenges', lecA: 'Complete ', lecB: ' lessons',
    rachaA: 'Keep a streak of ', rachaB: ' days', clasesA: 'Attend ', clasesB: ' class(es)',
    forosA: 'Take part in ', forosB: ' forum(s)', xpA: 'Earn ', xpB: ' XP', nivel: 'Complete level ', req: 'Meet the requirement'
  }
}

export default function Insignias({ usuario, onNuevaInsignia, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const etiquetaCat = cat => (idioma === 'en' && cat.en) ? cat.en : cat.label
  const [catalogo,  setCatalogo]  = useState([])
  const [ganadas,   setGanadas]   = useState([])
  const [cargando,  setCargando]  = useState(true)
  const [filtro,    setFiltro]    = useState('todas')

  useEffect(() => {
    if (!usuario) return
    cargarDatos()
  }, [usuario])

  async function cargarDatos() {
    setCargando(true)
    try {
      const [catRes, ganadRes] = await Promise.all([
        axios.get(API + '/curriculo/insignias/catalogo'),
        axios.get(API + '/curriculo/insignias/usuario/' + usuario.id)
      ])
      setCatalogo(catRes.data.datos || [])
      setGanadas(ganadRes.data.datos || [])
    } catch (err) { console.error(err) }
    finally { setCargando(false) }
  }

  async function verificarInsignias() {
    try {
      const res = await axios.post(API + '/curriculo/insignias/verificar', { usuario_id: usuario.id })
      if (res.data.nuevas && res.data.nuevas.length > 0) {
        onNuevaInsignia && onNuevaInsignia(res.data.nuevas)
        cargarDatos()
      }
    } catch (err) { console.error(err) }
  }

  useEffect(() => {
    if (usuario) verificarInsignias()
  }, [usuario])

  const codigosGanados = ganadas.map(g => g.insignia_codigo)
  const catalogoFiltrado = filtro === 'todas' ? catalogo : catalogo.filter(i => i.categoria === filtro)
  const totalGanadas = ganadas.length
  const totalCatalogo = catalogo.length
  const pct = Math.round((totalGanadas / Math.max(totalCatalogo, 1)) * 100)

  if (cargando) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:60, color:'#6B7280' }}>
      <div style={{ width:32, height:32, border:'3px solid #E2E6F0', borderTopColor:'#F59E0B', borderRadius:'50%', animation:'spinner .8s linear infinite' }} />
    </div>
  )

  return (
    <div style={{ maxWidth:900, margin:'0 auto', animation:'fadeIn .3s ease both' }}>

      {/* Header */}
      <div style={{ background:'linear-gradient(135deg,#92400E,#F59E0B)', borderRadius:16, padding:24, marginBottom:24, color:'#fff' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
          <span style={{ fontSize:36 }}>🏅</span>
          <div>
            <h1 style={{ fontSize:22, fontWeight:800, marginBottom:2 }}>{t.titulo}</h1>
            <p style={{ fontSize:13, opacity:.85 }}>{t.subtitulo}</p>
          </div>
          <div style={{ marginLeft:'auto', textAlign:'right' }}>
            <div style={{ fontSize:28, fontWeight:900 }}>{totalGanadas}/{totalCatalogo}</div>
            <div style={{ fontSize:12, opacity:.8 }}>{t.ganadasLbl}</div>
          </div>
        </div>
        <div style={{ height:8, background:'rgba(255,255,255,0.3)', borderRadius:999, overflow:'hidden' }}>
          <div style={{ width: pct + '%', height:'100%', background:'#fff', borderRadius:999, transition:'width .6s ease' }} />
        </div>
        <div style={{ fontSize:12, opacity:.8, marginTop:4 }}>{pct}% {t.completado}</div>
      </div>

      {/* Resumen por categoria */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:24 }}>
        {Object.entries(CATEGORIAS).map(([key, cat]) => {
          const total = catalogo.filter(i => i.categoria === key).length
          const obtenidas = ganadas.filter(g => {
            const ins = catalogo.find(c => c.codigo === g.insignia_codigo)
            return ins?.categoria === key
          }).length
          return (
            <div key={key} onClick={() => setFiltro(filtro === key ? 'todas' : key)}
              style={{ background: filtro===key ? cat.color : '#fff', border:'1.5px solid ' + (filtro===key ? cat.color : '#E2E6F0'),
                borderRadius:12, padding:'14px 16px', cursor:'pointer', transition:'all .15s' }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6 }}>
                <span style={{ fontSize:18 }}>{cat.ic}</span>
                <span style={{ fontSize:12, fontWeight:700, color: filtro===key ? '#fff' : '#374151' }}>{etiquetaCat(cat)}</span>
              </div>
              <div style={{ fontSize:20, fontWeight:800, color: filtro===key ? '#fff' : cat.color }}>
                {obtenidas}/{total}
              </div>
              <div style={{ height:4, background: filtro===key ? 'rgba(255,255,255,0.3)' : '#E2E6F0', borderRadius:999, marginTop:6, overflow:'hidden' }}>
                <div style={{ width: (obtenidas/Math.max(total,1)*100) + '%', height:'100%', background: filtro===key ? '#fff' : cat.color, borderRadius:999 }} />
              </div>
            </div>
          )
        })}
      </div>

      {/* Filtros */}
      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        <button onClick={() => setFiltro('todas')}
          style={{ padding:'6px 16px', borderRadius:999, border:'2px solid ' + (filtro==='todas' ? '#F59E0B' : '#E2E6F0'),
            background: filtro==='todas' ? '#F59E0B' : '#fff', color: filtro==='todas' ? '#fff' : '#374151',
            fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
          {t.todas}
        </button>
        <button onClick={() => setFiltro('ganadas')}
          style={{ padding:'6px 16px', borderRadius:999, border:'2px solid ' + (filtro==='ganadas' ? '#22C55E' : '#E2E6F0'),
            background: filtro==='ganadas' ? '#22C55E' : '#fff', color: filtro==='ganadas' ? '#fff' : '#374151',
            fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
          {t.ganadas} ({totalGanadas})
        </button>
        <button onClick={() => setFiltro('pendientes')}
          style={{ padding:'6px 16px', borderRadius:999, border:'2px solid ' + (filtro==='pendientes' ? '#6B7280' : '#E2E6F0'),
            background: filtro==='pendientes' ? '#6B7280' : '#fff', color: filtro==='pendientes' ? '#fff' : '#374151',
            fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
          {t.pendientes} ({totalCatalogo - totalGanadas})
        </button>
      </div>

      {/* Grid de insignias */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(240px, 1fr))', gap:12 }}>
        {(filtro === 'ganadas'
          ? catalogo.filter(i => codigosGanados.includes(i.codigo))
          : filtro === 'pendientes'
          ? catalogo.filter(i => !codigosGanados.includes(i.codigo))
          : catalogoFiltrado
        ).map(ins => {
          const ganada = codigosGanados.includes(ins.codigo)
          const datosGanada = ganadas.find(g => g.insignia_codigo === ins.codigo)
          const catInfo = CATEGORIAS[ins.categoria] || CATEGORIAS.especial

          return (
            <div key={ins.codigo}
              style={{ background: ganada ? 'linear-gradient(135deg,' + catInfo.color + '15,' + catInfo.color + '08)' : '#F9FAFB',
                border:'1.5px solid ' + (ganada ? catInfo.color + '60' : '#E2E6F0'),
                borderRadius:14, padding:20, position:'relative', overflow:'hidden',
                opacity: ganada ? 1 : 0.65, transition:'all .15s' }}>

              {ganada && (
                <div style={{ position:'absolute', top:10, right:10, background:'#22C55E', color:'#fff',
                  fontSize:10, fontWeight:800, padding:'2px 8px', borderRadius:999 }}>
                  {t.badgeGanada}
                </div>
              )}

              <div style={{ fontSize:44, marginBottom:10, filter: ganada ? 'none' : 'grayscale(100%)' }}>
                {ins.emoji}
              </div>

              <div style={{ fontSize:15, fontWeight:800, color: ganada ? '#1A1A2E' : '#6B7280', marginBottom:4 }}>
                {ins.nombre}
              </div>

              <div style={{ fontSize:12, color:'#6B7280', lineHeight:1.5, marginBottom:8 }}>
                {ins.descripcion}
              </div>

              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <span style={{ fontSize:11, background: catInfo.color + '20', color: catInfo.color,
                  padding:'2px 8px', borderRadius:999, fontWeight:600 }}>
                  {catInfo.ic} {etiquetaCat(catInfo)}
                </span>
                {ins.xp_bonus > 0 && (
                  <span style={{ fontSize:11, color:'#F59E0B', fontWeight:700 }}>
                    +{ins.xp_bonus} XP
                  </span>
                )}
              </div>

              {ganada && datosGanada?.ganada_en && (
                <div style={{ fontSize:11, color:'#9CA3AF', marginTop:8 }}>
                  {t.ganadaEl} {new Date(datosGanada.ganada_en).toLocaleDateString(t.locale)}
                </div>
              )}

              {!ganada && (
                <div style={{ fontSize:11, color:'#9CA3AF', marginTop:8, display:'flex', alignItems:'center', gap:4 }}>
                  🔒 {ins.requisito_tipo === 'reto_numero' ? t.reto + ins.requisito_valor
                    : ins.requisito_tipo === 'retos_total' ? t.retosA + ins.requisito_valor + t.retosB
                    : ins.requisito_tipo === 'lecciones_total' ? t.lecA + ins.requisito_valor + t.lecB
                    : ins.requisito_tipo === 'racha_dias' ? t.rachaA + ins.requisito_valor + t.rachaB
                    : ins.requisito_tipo === 'clases_total' ? t.clasesA + ins.requisito_valor + t.clasesB
                    : ins.requisito_tipo === 'foros_total' ? t.forosA + ins.requisito_valor + t.forosB
                    : ins.requisito_tipo === 'xp_total' ? t.xpA + ins.requisito_valor + t.xpB
                    : ins.requisito_tipo === 'nivel_completo' ? t.nivel + ins.requisito_detalle
                    : t.req}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
